<div class="flex flex-1 flex-col gap-2">
  @if (overrideControls.length) {
    @for (control of overrideControls; track $index; let index = $index) {
      <div class="flex flex-1 items-center gap-1">
        @if (control.value; as scopedCode) {
          <div
            *ngIf="scopedCode | map: resolveServiceCode as serviceCode"
            class="label flex"
          >
            <div>{{ serviceCode.code }} - {{ serviceCode.title }}</div>
            <mat-icon class="help-icon" [matTooltip]="serviceCode.description"
              >help_outline</mat-icon
            >
          </div>

          <span class="flex-1"></span>

          <span class="quantity">{{ scopedCode.quantity }} x </span>

          <mat-form-field class="price-input compact" subscriptSizing="dynamic">
            <span matTextPrefix>$&nbsp;</span>
            <mat-label>Price</mat-label>
            <input
              matInput
              type="number"
              min="0"
              step="0.01"
              [formControl]="control.controls.price"
            />
          </mat-form-field>
        }
      </div>
    }
  } @else {
    <span class="mat-caption">No service codes</span>
  }
</div>
